import React from 'react';

const perPersonPrice = (persons, per_person_price, fee) => {
    const price = persons * per_person_price;
    const admission_fees = price + (price  * fee / 100) + 0.30 + ((price + (price  * fee / 100)) * 0.029);
    return Math.ceil(admission_fees);
}

const PerPersonPrice = (props) => {
    return (
        <span className="font-weight-bold card_price">{perPersonPrice(props.persons, props.price, props.fee)}</span>
    )
}

export default PerPersonPrice;